import { Identity, IdentityQuestion } from 'merchant-api/types';
import { Stack } from 'react-bootstrap';
import {  Card, FormRadio, Navigation, useWizardContext } from '@odmonorepo/core-components';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { useApplication } from 'merchant-api/unified';


interface IdentityProps {
  identityData: Identity
}

export const IdentityForm = ({ identityData } : IdentityProps) => (

    <Stack gap={ 6 } style={{ maxWidth: '600px'}} className='mb-4'>
      <Card className="px-sm-6">
        <h4 className="pb-3" style={{ width: 'fit-content' }}>
          <FormattedMessage id="identity.cardTitle" />
        </h4>

        <Stack gap={ 4 } style={{ width: 'fit-content' }}>
          {identityData.questions.map((question: IdentityQuestion, idx: number) => (
            <>
              <FormRadio
              name={question.type.replace(/\./g, '_')}
              label={question.prompt}
              options={question.answerList}
              inline={false}
              useOptionAsLabel
              required
              useYupErrors
              />
              {idx < identityData.questions.length - 1 && (
              <hr className="border-medium-gray" />
              )}
            </>
          ))}
        </Stack>
      </Card>
    </Stack>
  )